import { createRouterSelector } from '@atlassian/react-resource-router';
import { ROUTE_NAMES_POLARIS_COLLECTIONS } from '@atlassian/jira-common-constants/src/spa-routes.tsx';

export const useCollectionSelected = createRouterSelector(({ route, match }) => {
	const viewUUID = match.params?.resource;
	const collectionUUID = match.params?.collectionUUID || undefined;

	const isCollectionSelected =
		route.name === ROUTE_NAMES_POLARIS_COLLECTIONS && viewUUID !== undefined;

	return isCollectionSelected ? collectionUUID : undefined;
});

type UseIsCollectionSelectedOptions = {
	collectionUUID: string;
};

export const useIsCollectionSelected = (options?: UseIsCollectionSelectedOptions) => {
	const collectionSelected = useCollectionSelected();

	if (options?.collectionUUID) {
		return collectionSelected === options.collectionUUID;
	}

	return Boolean(collectionSelected);
};
